import { useEffect } from 'react';

import { useIwocaPayFunctionality } from './hooks/useIwocaPayFunctionality';
import MainContentPending from '../../pageStructure/mainContentPending';

export function IwocapayDashboardRedirect({
    children
}: {
    children: React.ReactNode;
}) {
    const { functionalities, isLoading } = useIwocaPayFunctionality({
        functionalities: ['use_circe_account_pages']
    });

    const shouldRedirect = functionalities.use_circe_account_pages;

    useEffect(() => {
        if (shouldRedirect) {
            const queryParams = new URLSearchParams(window.location.search);
            window.location.href = `/pay/account/?${queryParams.toString()}`;
        }
    }, [shouldRedirect]);

    if (isLoading || shouldRedirect) {
        return <MainContentPending />;
    }

    return <>{children}</>;
}
